import * as types from "./types";

const mutations = {
    [types.LOADING_TIMESHEET](state, value) {
        state.loading = value;
    },
    [types.GET_TIMESHEET_LIST](state, timesheet) {
        state.timesheet = timesheet;
    },
    [types.GET_TIMESHEET_ID](state, timesheetId) {
        state.timesheetId = timesheetId;
    },
    [types.GET_TIMESHEET_ID](state, timesheetStatus) {
        state.timesheetStatus = timesheetStatus;
    },
    [types.REMOVE_TIMESHEET](state, id) {        
        state.timesheet = state.timesheet.filter((x) => x.id !== id);        
    },
    [types.ADD_TIMESHEET](state, timesheet) {        
        state.timesheet.unshift(timesheet);
    },
    [types.UPDATE_TIMESHEET](state, timesheet) {        
        const timesheetIndex = state.timesheet.findIndex((x) => x.id === timesheet.id);
        state.timesheet[timesheetIndex] = timesheet;        
    }
};

export default mutations;